module.exports = __webpack_public_path__ + "static/media/YB5F12_1.7858ce0d.jpg";